// Used to match internal channel names to user-facing names
const translations = {
  sms:   'SMS',
  email: 'Email',
  gbc:   'Google'
};


export function hasAvailable(customer) {
  return !!customer?.contact?.channels?.available?.length;
}


export function getPreferredChannel(customer) {
  if (!hasAvailable(customer))
    return null;

  const channel = customer.contact.channels.preferred;
  return channelToLabel(channel);
}


export function channelToLabel(channel) {
  return translations[channel] || channel;
}
